<h2 mat-dialog-title>Delete Custom Reimbursement Category</h2>

<div mat-dialog-content class="rollover-dialog-content">
  <p class="rollover-dialog-message">
    Choose what should happen to any rollover balance in
    <strong>{{ data.sourceCategoryName }}</strong>.
  </p>

  <mat-radio-group
    class="rollover-dialog-options"
    [value]="action"
    (change)="onActionChange($event.value)"
    >
    <mat-radio-button class="rollover-dialog-option" value="transfer_to_category" [disabled]="!hasTransferTargets">
      Transfer to another custom category
    </mat-radio-button>

    @if (action === 'transfer_to_category') {
      <mat-form-field
        class="rollover-dialog-target"
        appearance="outline"
        >
        <mat-label>Target category</mat-label>
        <mat-select [(ngModel)]="targetCategoryId">
          @for (category of data.targetCategories; track category) {
            <mat-option [value]="category.id">
              {{ category.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (submitAttempted && showTargetCategoryError) {
      <div class="rollover-dialog-error">
        Select a target category to continue.
      </div>
    }

    <mat-radio-button class="rollover-dialog-option" value="return_to_employer_external">
      Return to employer funding method now (direct refund push)
    </mat-radio-button>

    <mat-radio-button class="rollover-dialog-option" value="return_to_employer_internal">
      Hold internally for balance reclaim only
    </mat-radio-button>

    <mat-radio-button class="rollover-dialog-option" value="leave_unrestricted">
      Leave usable without restriction in member Wellness balances
    </mat-radio-button>
  </mat-radio-group>
</div>

<div mat-dialog-actions class="rollover-dialog-actions">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="onConfirm()">
    Continue
  </button>
</div>
